import user from '@/router/middleware/user.js'
import AdminLayout from '@/Layouts/AdminLayout'
import AuthLayout from '@/Layouts/AuthLayout.vue'

export default [
  {
    path: '/driver/signup',
    name: 'Driver SignUp',
    component: () => import(/* webpackChunkName: "signUpDriver" */'@/views/Site/Authentication/signUpDriver'),
    meta: {
      layout: AuthLayout,
      title: 'Driver Sign Up'
    }
  },
  {
    path: '/driver/profile/complete',
    name: 'DriverProfileCompletion',
    component: () => import(/* webpackChunkName: "DriverProfileCompletion" */ '@/views/Site/Authentication/DriverProfileCompletion.vue'),
    meta: {
      layout: AuthLayout,
      title: 'Driver Profile Completion'
    }
  },
  {
    path: '/driver/dashboard',
    name: 'DriverDashboard',
    component: () => import(/* webpackChunkName: "DriverDashboard" */ '@/views/Admin/Driver/dashboard.vue'),
    meta: {
      layout: AuthLayout,
      title: 'Driver Dashboard'
    }
  },
  {
    path: '/driver/profile',
    name: 'driverProfile',
    component: () => import(/* webpackChunkName: "driverProfile" */ '@/views/Admin/Driver/profile'),
    beforeEnter: user,
    meta: {
      layout: AdminLayout,
      title: 'Profile'
    }
  },
  {
    path: '/driver/completed-rides',
    name: 'DriverCompletedRide',
    component: () => import(/* webpackChunkName: "DriverCompletedRide" */ '@/views/Admin/riders/CompletedRide/completed.vue'),
    beforeEnter: user,
    meta: {
      layout: AdminLayout,
      title: 'Completed Rides'
    }
  }
]
